/**
 * User Block Component
 */
import {Button, Menu, MenuItem, Paper} from '@material-ui/core';
import {AccountCircle as AccountCircleIcon} from '@material-ui/icons';
import * as React from 'react';
import {connect} from 'react-redux';
import {Link, RouteChildrenProps, withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {logoutUser, startUserTour, stopUserTour} from '../../actions';
import {
    accessTokenLocalStorageKey,
    resourceCustomUsers,
    dataIsValidAfterDelete,
    dataIsValidAfterSave,
    dataValidityKey,
    realtimeDataReducerKey,
} from '../../constants';
import storage from '../../fetchApi/storage';
import {GET_ONE} from '../../fetchApi/types';
import {withDataProvider} from '../../fetchApi/dataProvider';
import IntlMessage from '../../util/IntlMessage';
import {withStyles} from '@material-ui/styles';
import {get} from 'lodash';
import {DataProvider} from '../../fetchApi/tsTypes';
import {BITBUCKET_BUILD_NUMBER} from '../../deployVersion';

interface UserBlockProps extends RouteChildrenProps {
    logoutUser: Function;
    startUserTour: Function;
    dataIsValid: boolean;
    dataProvider: DataProvider;
    runUserTour: boolean;
    stopUserTour: Function;
}

interface UserBlockState {
    isSupportModal: boolean;
    userInfo: Record<string, any>;
    serverVersion: string | null;
    anchorEl: HTMLElement | null;
}

const CustomMenuItem = ({classes, children, ...rest}: Record<string, any>) => (
    <MenuItem {...rest} className={classes.root}>
        {children}
    </MenuItem>
);

const StyledMenuItem = compose(withStyles({
    root: {
        minHeight: 48,
    },
}))(CustomMenuItem);

const spanStyle = {
    paddingRight: 16,
    width: 'auto',
    display: 'block',
    textAlign: 'end',
    minWidth: '220px'
};

const versionPrefix = '1.0.';

class UserBlock extends React.Component<UserBlockProps, UserBlockState> {
    constructor(props: UserBlockProps) {
        super(props);
        this.state = {
            isSupportModal: false,
            userInfo: {},
            anchorEl: null,
            serverVersion: null
        };
    }

    componentDidMount(): void {
        this.getUserInfo();
    }

    componentDidUpdate(prevProps: Readonly<UserBlockProps>) {
        const {dataIsValid} = this.props;
        if (prevProps.dataIsValid && !dataIsValid) {
            this.getUserInfo();
        }
    }

    getUserInfo = () => {
        const {logoutUser, dataProvider} = this.props;
        const lbToken = storage.load(accessTokenLocalStorageKey);
        if (!lbToken) {
            logoutUser({redirectTo: '/signin'});
        }
        dataProvider(GET_ONE, resourceCustomUsers, {id: lbToken.userId})
            .then((data) => {
                if (data.data) {
                    if (data.data.email) {
                        $crisp.push(["set", "user:email", data.data.email]);
                    }

                    this.setState({userInfo: data.data, serverVersion: data.serverVersion});
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    logoutUser = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        const {logoutUser} = this.props;
        e.preventDefault();
        logoutUser({redirectTo: '/signin'});
    };

    restartUserTour = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        const {startUserTour} = this.props;
        e.preventDefault();
        setTimeout(() => startUserTour(), 200);
    };

    closeMenu = () => {
        this.setState({anchorEl: null});
    };

    openMenu = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        const {runUserTour, stopUserTour} = this.props;
        if (runUserTour) {
            stopUserTour();
        }

        this.setState({anchorEl: e.currentTarget});
    };

    render() {
        const {userInfo, anchorEl, serverVersion} = this.state;

        return (
            <div className="top-sidebar">
                <div
                    className="sidebar-user-block"
                    data-user-tour='step-start-tour-again'
                >
                    <Button onClick={this.openMenu} className="user-block-button">
                        <div className="d-flex align-items-center justify-content-between">
                            {userInfo.pictureUrl ? (
                                <img
                                    src={userInfo.pictureUrl}
                                    alt="user picture"
                                    className="img-fluid rounded-circle"
                                    width="35"
                                    height="35"
                                />
                            ) : (
                                <AccountCircleIcon fontSize="large" className="img-fluid rounded-circle" />
                            )}
                            <div className="user-info">
                                <span className="user-name-profile ml-2">{userInfo.fullName || userInfo.email}</span>
                                <i className="zmdi zmdi-chevron-down dropdown-icon ml-1 mt-1 user-name-profile-arrow" />
                            </div>
                        </div>
                    </Button>
                    <Menu
                        open={!!anchorEl}
                        onClose={this.closeMenu}
                        anchorEl={anchorEl}
                        MenuListProps={{className: 'pt-0'}}
                    >
                        <MenuItem
                            className="p-0"
                            component={Link}
                            to={{
                                pathname: '/profile',
                                state: {activeTab: 0},
                            }}
                            onClick={this.closeMenu}
                        >
                            <Paper className="bg-primary w-100 p-15 border-bottom pb-3">
                                <p className="text-white mb-0 fs-14 user-name">{userInfo.fullName}</p>
                                <span className="text-white fs-14 user-name">{userInfo.email}</span>
                            </Paper>
                        </MenuItem>
                        <StyledMenuItem
                            component={Link}
                            to={{
                                pathname: '/profile',
                                state: {activeTab: 0},
                            }}
                            onClick={this.closeMenu}
                        >
                            <i className="zmdi zmdi-account text-primary mr-3" />
                            <IntlMessage id="widgets.profile" />
                        </StyledMenuItem>
                        <StyledMenuItem
                            onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
                                this.closeMenu();
                                this.restartUserTour(e);
                            }}
                        >
                            <i className="zmdi zmdi-info-outline text-primary mr-3" />
                            <IntlMessage id="widgets.user_tour" />
                        </StyledMenuItem>
                        {/*<MenuItem>*/}
                        {/*    <Link*/}
                        {/*        to={{*/}
                        {/*            pathname: '/users/user-profile-1',*/}
                        {/*            state: {activeTab: 2},*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        <i className="zmdi zmdi-comment-text-alt text-success mr-3" />*/}
                        {/*        <IntlMessage id="widgets.messages" />*/}
                        {/*    </Link>*/}
                        {/*</MenuItem>*/}
                        {/*<MenuItem>*/}
                        {/*    <Link to="/pages/feedback">*/}
                        {/*        <i className="zmdi zmdi-edit text-warning mr-3" />*/}
                        {/*        <IntlMessage id="breadcrumbs.feedback" />*/}
                        {/*    </Link>*/}
                        {/*</MenuItem>*/}
                        <StyledMenuItem
                            onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
                                this.closeMenu();
                                this.logoutUser(e);
                            }}
                        >
                            <i className="zmdi zmdi-power text-danger mr-3" />
                            <IntlMessage id="widgets.logOut" />
                        </StyledMenuItem>
                        {Number(BITBUCKET_BUILD_NUMBER) === Number(serverVersion) ?
                            <span className="fs-10 fixed-right"
                                  style={spanStyle}>App version: {versionPrefix}{serverVersion}</span>
                            : Number(BITBUCKET_BUILD_NUMBER) > Number(serverVersion) ?
                                <span className="fs-10 fixed-right text-danger"
                                      style={spanStyle}>Versions mismatch: {versionPrefix}{BITBUCKET_BUILD_NUMBER}({serverVersion})</span>
                                : <span className="fs-10 fixed-right text-danger"
                                        style={spanStyle}>Versions mismatch: {versionPrefix}{BITBUCKET_BUILD_NUMBER}({serverVersion})<br/>reload in 3 mins</span>
                        }
                    </Menu>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    const userDataValidity = get(state, [realtimeDataReducerKey, resourceCustomUsers, dataValidityKey], null);
    const runUserTour = get(state, 'settings.userTour.runUserTour', false);

    let dataIsValid = true;
    if (userDataValidity) {
        dataIsValid = userDataValidity[dataIsValidAfterSave] && userDataValidity[dataIsValidAfterDelete];
    }

    return {
        runUserTour,
        dataIsValid,
    };
};

export default compose(
    connect(mapStateToProps, {logoutUser, startUserTour, stopUserTour}),
    withRouter,
    withDataProvider,
)(UserBlock);